import styled from 'styled-components';

export const Wrapper = styled.div<{ animateOut: boolean; noSpacing: boolean }>`
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99999;
  padding: ${({ noSpacing }) => (noSpacing ? '0' : '85px 16px')};
  display: flex;
  flex-flow: column nowrap;
  overflow: auto;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  animation: ${({ animateOut }) =>
    animateOut ? 'fade-out 0.1s linear forwards' : 'fade-in 0.1s linear forwards'};
`;

export const Backdrop = styled.div`
  position: fixed;
  height: 100vh;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  background-color: rgb(0 0 0 / 60%);
`;

export const CloseBtn = styled.button`
  position: relative;
  background-color: #0e1216;
  width: 62px;
  height: 62px;
  top: -30px;
  border-radius: 40px;
  border: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
